function AppLayout({ children }) {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="mx-auto w-full max-w-md px-4 py-6 sm:max-w-lg md:max-w-2xl">
        {children}
      </div>
    </div>
  );
}

export default AppLayout;
